module.exports = __webpack_public_path__ + "img/eleStatus.7ec2a89b.png";